import { Typography } from '@altify/components';
import usePageConfig from 'hooks/usePageConfig';
import { exploreProductsContent } from '../explore.content';
import { useContent } from '@altify/utils';

const NoProductsFound = () => {
  const pageConfig = usePageConfig();
  const supportEmail = pageConfig?.app?.supportEmail || 'support@altify.app';
  const localizedContent = useContent(exploreProductsContent);

  return (
    <div className="flex flex-col items-start px-2">
      <Typography className="text-error mb-8" size="medium">
        {localizedContent.noResultsFound}
      </Typography>
      <Typography size="medium">{localizedContent.suggestNewAsset}</Typography>
      <a href={`mailto:${supportEmail}`}>
        <Typography size="medium" weight="medium">
          {supportEmail}
        </Typography>
      </a>
    </div>
  );
};

export default NoProductsFound;
